import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import { CampaignEditor } from '@/pages/campaigns/editor';
import { requireRoutePermission } from '@/lib/route-guard';

export const Route = createFileRoute('/_authenticated/campaigns/new')({
  beforeLoad: () => requireRoutePermission(P.OUTREACH_EDIT),
  component: NewCampaign,
});

function NewCampaign(): React.ReactElement {
  const navigate = useNavigate();
  return (
    <CampaignEditor
      onClose={() => void navigate({ to: '/campaigns' })}
      onSaved={(id) => void navigate({ to: '/campaigns/$id', params: { id }, replace: true })}
    />
  );
}
